import { docReady } from './utils';

const renderHorarios = () => {
  const container = document.querySelector('[data-horarios]');
  if (!container) return;

  const apiUrl =
    container.dataset.apiUrl ||
    'https://app.base44.com/api/apps/683dbd489f14ec990e60cd33/entities/LinhaTransporte';

  const setContent = (html) => {
    container.innerHTML = html;
  };

  const formatHorarios = (item) => {
    const dayLabels = {
      dia_util: 'Dia útil',
      sabado: 'Sábado',
      domingo_feriado: 'Domingo/Feriado',
    };

    const { horarios } = item;
    if (!Array.isArray(horarios) || !horarios.length) return 'Horários não informados';

    const grupos = { ida: {}, volta: {} };

    horarios.forEach((h) => {
      const sentido = (h.sentido || 'ida').toLowerCase();
      const tipo = h.tipo_dia || 'dia_util';
      const partida = (h.horario_partida || '').trim();
      if (!partida) return;
      if (!grupos[sentido]) grupos[sentido] = {};
      if (!grupos[sentido][tipo]) grupos[sentido][tipo] = [];
      grupos[sentido][tipo].push(partida);
    });

    const labelSentido = (sentido) => {
      if (sentido === 'volta') return item.itinerario_volta?.[0]?.nome_parada || 'Volta';
      return item.itinerario_ida?.[0]?.nome_parada || 'Ida';
    };

    const buildSentido = (sentidoKey) => {
      const tipos = grupos[sentidoKey] || {};
      if (!Object.keys(tipos).length) return '';
      const titulo = `${labelSentido(sentidoKey).toUpperCase()} (${sentidoKey.toUpperCase()})`;
      const linhas = Object.entries(tipos)
        .map(
          ([tipo, partidas]) =>
            `<div class="mb-1"><span class="fw-bold text-900">${dayLabels[tipo] || tipo}:</span> ${partidas.join(', ')}</div>`
        )
        .join('');
      return `<div class="mb-3">
        <p class="mb-1 fw-bold text-secondary">${titulo}</p>
        ${linhas || '<p class="mb-0 text-secondary">Sem horários informados.</p>'}
      </div>`;
    };

    const ida = buildSentido('ida');
    const volta = buildSentido('volta');
    const html = `${ida}${volta}`;
    return html || 'Horários não informados';
  };

  const formatItinerario = (itinerario) => {
    if (!Array.isArray(itinerario) || !itinerario.length) return '';
    const pontos = itinerario
      .slice(0, 4)
      .map((p) => p.nome_parada || '')
      .filter(Boolean)
      .join(' → ');
    return pontos ? `<p class="mb-1 text-secondary">Itinerário: ${pontos}${itinerario.length > 4 ? ' ...' : ''}</p>` : '';
  };

  const toHtml = (items) => {
    if (!items.length) {
      return '<p class="mb-0 text-secondary">Nenhuma linha encontrada no momento.</p>';
    }
    const accordionId = 'horariosAccordion';
    const cards = items
      .map((item) => {
        const nome = item.nome_linha || 'Linha sem nome';
        const codigo = item.codigo_linha || '';
        const sentido = item.sentido || '';
        const horarios = formatHorarios(item);
        const observacoes = item.observacoes || '';
        const ida = formatItinerario(item.itinerario_ida);
        const volta = formatItinerario(item.itinerario_volta);
        const collapseId = `collapse-${item.id || codigo || nome.replace(/\s+/g, '-')}`;

        return `
          <div class="accordion-item border-0 mb-2 shadow-sm">
            <h2 class="accordion-header" id="heading-${collapseId}">
              <button class="accordion-button collapsed px-3 py-2" type="button" data-bs-toggle="collapse" data-bs-target="#${collapseId}" aria-expanded="false" aria-controls="${collapseId}">
                <div>
                  <h6 class="text-secondary fw-bold mb-1">${nome}</h6>
                  <p class="mb-0 text-900 small">${codigo}${codigo && sentido ? ' • ' : ''}${sentido}</p>
                </div>
              </button>
            </h2>
            <div id="${collapseId}" class="accordion-collapse collapse" aria-labelledby="heading-${collapseId}" data-bs-parent="#${accordionId}">
              <div class="accordion-body">
                <div class="mb-2 fw-medium text-900">${horarios}</div>
                ${ida}${volta}
                ${observacoes ? `<p class="mb-0 text-secondary">${observacoes}</p>` : ''}
              </div>
            </div>
          </div>
        `;
      })
      .join('');
    return `<div class="accordion" id="${accordionId}">${cards}</div>`;
  };

  fetch(apiUrl, {
    headers: {
      api_key: '5fd0929fa17345008eea70de757f5aff',
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) throw new Error('Falha ao carregar horários');
      return response.json();
    })
    .then((data) => {
      const items = Array.isArray(data) ? data : data?.items || data?.data || [];
      setContent(toHtml(items));
    })
    .catch(() => {
      setContent('<p class="mb-0 text-danger">Não foi possível carregar os horários agora. Tente novamente em instantes.</p>');
    });
};

docReady(renderHorarios);
